module.exports = __webpack_public_path__ + "static/img/yg_role.0d82517.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/yg_role.png
// module id = VPqP
// module chunks = 7